import {defineStore} from "pinia";
import useSharedMethod from "@/use/SharedMethod";
import axios from "axios";

export const useControlProgramStore = defineStore('controlProgram', {
    state: () => ({
        controlProgram: {},
        controlPrograms: [],
    }),
    actions: {
        setControlProgram(controlProgram) {
            this.controlProgram = controlProgram
        },
        setControlPrograms(controlPrograms) {
            this.controlPrograms = controlPrograms
        },
        addControlProgram(controlProgram) {
            this.controlPrograms.unshift(controlProgram)
        },
        updateControlProgram(controlProgram) {
            let index = this.controlPrograms.findIndex(cl => cl.id === controlProgram.id)
            this.controlPrograms.splice(index, 1, controlProgram)
        },
        deleteControlProgram(controlProgram) {
            let index = this.controlPrograms.findIndex(cl => cl.id === controlProgram.id)
            this.controlPrograms.splice(index, 1)
        },
        findAll(filter) {
            const {transformFilterValues} = useSharedMethod();
            this.loading = true;
            axios.get('/controlPrograms', {params: transformFilterValues(filter)}).then((response) => {
                this.controlPrograms = response.data.elements;
            }).finally(() => {
                this.loading = false;
            });
        },

    },
});